var sourceUrl;
var documentWidth = $(document).width();
var datePickerMode = localStorage.getItem("datePickerMode") ? Number(localStorage.getItem("datePickerMode")) : 2;

$(window).resize(function () {
  documentWidth = $(document).width();
});

$(function () {
  // datePicker();

  // show more description in property
  $(".js-cip-show-more").on("click", function () {
    $(".js-cip-property-footer-content").toggleClass("auto-height");
    $(this).toggleClass("active");
  });

  $(".js-cip-booking-infant-info").click(function () {
    $(this).closest(".js-cip-travelers").find(".js-cip-booking-infant-description").slideDown();
  });

  $(".js-cip .js-cip-auto-search").each(function () {
    autoSearch($(this));
  });

  var sum = 0;
  $(".js-cip-count-box .js-cip-max").click(function () {
    var $this = $(this).closest(".js-cip-travelers");
    if (sum < 9) {
      $this.find(".js-cip-validation-economy").text("");

      var num = Number($(this).parent().find(".js-cip-number-passenger").text());
      var temp = num + 1;

      var babyNumber = Number($this.find(".js-cip-passenger-infant").find(".js-cip-number-passenger").text());

      var adultNumber = Number($this.find(".js-cip-passenger-adult").find(".js-cip-number-passenger").text());

      if ($(this).closest("li").hasClass("js-cip-passenger-adult")) {
        $(this).parent().find(".js-cip-number-passenger").text(temp);
        $(this).closest(".js-cip-economy-target").find(".js-cip-adults-number").text(temp);
      } else if ($(this).closest("li").hasClass("js-cip-passenger-infant")) {
        if (babyNumber < adultNumber) {
          $(this).parent().find(".js-cip-number-passenger").text(temp);
          $(this).closest(".js-cip-economy-target").find(".js-cip-infant-number").text(temp);
        } else {
          $(".js-cip-validation-economy").text("تعداد نوزاد نمی تواند بیشتر از تعداد بزرگسال باشد");
        }
      } else {
        $(this).parent().find(".js-cip-number-passenger").text(temp);
        $(this).closest(".js-cip-economy-target").find(".js-cip-child-number").text(temp);
      }

      calcSum($(this).closest(".js-cip-economy-target"));
    } else {
      $this.find(".js-cip-validation-economy").text("تعداد کل مسافرین نمیتواند بیشتر از 9 نفر باشد");
    }
  });

  $(".js-cip-count-box .js-cip-min").click(function () {
    var $this = $(this).closest(".js-cip-economy-target");
    $(".js-cip-validation-economy").text("");

    var num = Number($(this).parent().find(".js-cip-number-passenger").text());

    var min = Number($(this).parent().find(".js-cip-number-passenger").data("min"));

    var temp = num > min ? num - 1 : num;

    var babyNumber = Number(
      $(this).closest(".js-cip-travelers").find(".js-cip-passenger-infant").find(".js-cip-number-passenger").text()
    );
    var adultNumber = Number($(this).parent().find(".js-cip-number-passenger").text());
    if ($(this).closest("li").hasClass("js-cip-passenger-adult")) {
      if (babyNumber < adultNumber) {
        $(this).parent().find(".js-cip-number-passenger").text(temp);
        $this.find(".js-cip-adults-number").text(temp);
      } else {
        $(".js-cip-validation-economy").text("تعداد بزرگسال نمی تواند کمتر از تعداد نوزاد باشد");
      }
    } else if ($(this).closest(".js-cip-passenger-list").hasClass("js-cip-passenger-infant")) {
      $(this).parent().find(".js-cip-number-passenger").text(temp);
      $this.find(".js-cip-infant-number").text(temp);
    } else {
      $(this).parent().find(".js-cip-number-passenger").text(temp);
      $this.find(".js-cip-child-number").text(temp);
    }
    calcSum($(this).closest(".js-cip-booking-container"));
  });

  $(".js-cip .js-cip-economy-target").each(function () {
    calcSum($(this));
  });

  function calcSum(obj) {
    sum = 0;
    obj.find("li.js-cip-passenger-list .js-cip-number-passenger").each(function () {
      sum += Number($(this).text());
      obj.find(".js-cip-travelers-number .js-cip-number").text(sum);
    });
  }

  //traveller menu close

  $(document).click(function (e) {
    if (
      !$(".js-cip-economy-target").is(e.target) && // if the target of the click isn't the container...
      $(".js-cip-economy-target").has(e.target).length === 0
    ) {
      if ($(window).width() > 767) {
        // ... nor a descendant of the container
        $(".js-cip-travelers").fadeOut();
      } else {
        $(".js-cip-travelers").removeClass("show-tmenu");
      }
    }
  });
});

function GetLanguage() {
  return window.location.pathname.split("/")[1];
}

//economy click
$(document).delegate(".js-cip-economy-target>button", "click", function () {
  $(this).next(".js-cip-travelers").fadeToggle();
  $(this).next(".js-cip-travelers").toggleClass("show-mobile");
  if (documentWidth < 992) {
    $("html").addClass("no-scroll");
  }
});

//remove input text

$(document).delegate(".js-cip-close-tmenu", "click", function () {
  $(this).closest(".js-cip-travelers").hide();
  $("html").removeClass("no-scroll");
});

// sort arrayObject
function sortArrayObject(key, order = "asc") {
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    var varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    var varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    var comparison = 0;

    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order == "desc" ? comparison * -1 : comparison;
  };
}

var citylist = [];

//layout in mobile
$(".js-cip").delegate(".js-cip-input-layout", "click", function () {
  $(this).closest(".js-cip-city").addClass("show-mobile");

  $(this).closest(".js-cip-city").find("input").trigger("focus");

  $(this).closest(".js-cip-city").find("input").trigger("search");
});

$(".js-cip-booking .js-inc-datepicker-calendar").pickDate({
  dateFormat: "yy/mm/dd",
  dateFormatEn: "yy M dd",
  changeMonthAllow: false,
  changeYearAllow: false,
  showButtonPanel: true,
  isDependenceDates: false,
  showCurrentAtPos: 0,
  numberOfMonths: $(window).width() > 991 ? 2 : 1,
  // yearRange: "c-100:+00",
  minDate: -0,
  customClass: "lightTheme",
  showAllMonthsinList: false,
  langType: datePickerMode === 1 ? '':'fa',
  blurInmobile: true,
  dayNamesShortFa: ["1شنبه", "2شنبه", "3شنبه", "4شنبه", "5شنبه", "جمعه", "شنبه"],
  dayNamesShortEn: ["Su", "Mo", "TU", "We", "Th", "Fr", "Sa"],
  enterDateTitle: "تاریخ",
  enterDateTitleEn: "Date",
  fillHidden: {
    enable: true,
    outPut: "en", //en | Dependent_On_SelectedDate | fa
    customformatInhidden: "YYYY-MM-DD",
  },
});

// select airport //////////////////////////////////

var cipLocationList;

$(function () {
  if (window.cipDays && window.cipDays.length) {
    appendTravelTimeList(window.cipDays);
  }

  if (window.cipAirlines && window.cipAirlines.length) {
    cipLocationList = window.cipAirlines;
  } else {
    $.get("/cip-api/searchtitle/", function (data, status) {
      if (data.model && data.model.length) {
        cipLocationList = data.model;
      }
    });
  }

  // $.get("/cip-api/searchtitle/", function (data, status) {
  //   if (data.model && data.model.length) {
  //     appendTravelTimeList(data.model);
  //   }
  // });

  $(".js-search-cip").click(function () {
    var localStorageKey = `${window.prefixSearchHistory}-${
      $(".js-search-holder-landing").attr("id") ||
      $(this).closest(".js-tab-nav").find(".js-tab-content>div.active").attr("id")
    }`;
    var searchHistoryItem = {
      value: {},
      baseUrl: "",
      expire: "",
    };

    var baseUrl = "/cipSearch/?";
    var valid = true;

    $(".js-cip-booking").find(".js-error-message").remove();
    $(".js-cip-booking-input").removeClass("error");

    if ($(".js-cip-location").data("code")) {
      baseUrl += "ac=" + $(".js-cip-location").data("code");
      searchHistoryItem.value.ciLlocation = {
        code: $(".js-cip-location").data("code"),
        value: $(".js-cip-location").data("value"),
        title: $(".js-cip-location").attr("placeholder"),
      };
    } else {
      $(".js-cip-location").closest(".js-cip-booking-input").addClass("error");
      valid = false;
    }

    searchHistoryItem.value.date = [];
    $(".js-cip-booking .pickDate").each(function (index, value) {
      searchHistoryItem.value.date[index] = "";
      if ($(this).val() !== "") {
        searchHistoryItem.value.date[index] = $(this).next().val();
        baseUrl += "&st=" + $(this).next().val();
      } else {
        $(this).closest(".js-cip-booking-input").addClass("error");
        valid = false;
      }
    });

    searchHistoryItem.expire = searchHistoryItem.value.date[0] ?? "";

    if ($(".js-cip-passenger-adult").find(".js-cip-number-passenger").text()) {
      baseUrl += "&adt=" + $(".js-cip-passenger-adult").find(".js-cip-number-passenger").text();
    }
    if ($(".js-cip-passenger-child").find(".js-cip-number-passenger").text() > 0) {
      baseUrl += "&cht=" + $(".js-cip-passenger-child").find(".js-cip-number-passenger").text();
    }
    if ($(".js-cip-passenger-infant").find(".js-cip-number-passenger").text() > 0) {
      baseUrl += "&inf=" + $(".js-cip-passenger-infant").find(".js-cip-number-passenger").text();
    }

    searchHistoryItem.value.passenger = {
      adult: $(".js-cip-passenger-adult").find(".js-cip-number-passenger").text(),
      child: $(".js-cip-passenger-child").find(".js-cip-number-passenger").text(),
      infant: $(".js-cip-passenger-infant").find(".js-cip-number-passenger").text(),
    };

    searchHistoryItem.value.type = {
      flighttype: "",
      triptype: "",
    };

    if ($(".js-cip-type-booking-input").find(".js-cip-type").data("flighttype")) {
      baseUrl += "&ft=" + $(".js-cip-type-booking-input").find(".js-cip-type").data("flighttype");
      searchHistoryItem.value.type.flighttype = $(".js-cip-type-booking-input").find(".js-cip-type").data("flighttype");
    } else {
      $(".js-cip-location").closest(".js-cip-booking-input").addClass("error");
      valid = false;
    }
    if ($(".js-cip-type-booking-input").find(".js-cip-type").data("triptype")) {
      baseUrl += "&tt=" + $(".js-cip-type-booking-input").find(".js-cip-type").data("triptype");
      searchHistoryItem.value.type.triptype = $(".js-cip-type-booking-input").find(".js-cip-type").data("triptype");
    } else {
      $(".js-cip-location").closest(".js-cip-booking-input").addClass("error");
      valid = false;
    }

    if (!valid) {
      $(".js-cip-booking").append(
        "<span class='form-validation js-error-message'>لطفا تمام فیلدها را کامل نمایید</span>"
      );

      return false;
    } else {
      searchHistoryItem = {
        ...searchHistoryItem,
        baseUrl: baseUrl,
      };

      window.updateLocalStorage(localStorageKey, searchHistoryItem);
      window.location.assign(baseUrl);
    }
  });

  var cipFlightTypeList;
  var cipTripTypeList;

  // init location autoComplete
  $(".js-cip-location")
    .autocomplete({
      minLength: 0,
      source: function (request, response) {
        if (request.term === "" && cipLocationList) {
          var items = cipLocationList && cipLocationList.length ? cipLocationList : [];
          response(items);
        } else {
          var url = getResult($(".js-cip-location"));
          $.getJSON(url).done(function (serverResponse) {
            response(serverResponse.model);
          });
        }
      },
      appendTo: $(".js-cip-location").next(),
      search: function () {
        $(this).closest(".js-cip-booking-input").addClass("is-open");

        if (window.innerWidth < 993) {
          $("html").addClass("no-scroll");
        }
      },
      select: function (event, ui) {
        if($(this).data('code') && $(this).data('code') !== ui.item.airportCode) {
          let target = $(document.querySelector(".js-cip-type"))
          target.removeAttr("data-triptype")
          target.removeAttr("data-flighttype")
          target.attr("placeholder", 'نوع پرواز / نوع سفر')
          target.val('')
          target.data({
            triptype: null,
            flighttype: null
          })
        }

        $(this).attr("data-code", ui.item.airportCode);
        $(this).attr("data-value", ui.item.airportEnglishTitle);
        $(this).val();

        $(this).data({
          code: ui.item.airportCode,
          value: ui.item.airportEnglishTitle,
        });

        $(this).attr("placeholder", ui.item.airportTitle);

        cipFlightTypeList = ui.item.flightTypes;
        cipTripTypeList = ui.item.tripTypes;
        $(this).closest(".js-cip-booking-input").removeClass("is-open");
        flightType();

        let timeOut = setTimeout(() => {
          document.querySelector(".js-cip-type").click();
          clearTimeout(timeOut);
        }, 100);
      },

      close: function (e, ui) {
        $("html").removeClass("no-scroll");
      },
      open: function () {
        let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
        if (chromeAgent) {
          $(this).attr("autocomplete", "off");
        }
      },
    })
    .bind("focus", function () {
      $(this).val("");
      $(this).autocomplete("search");
      // $(this).keydown();
    })
    .bind("blur", function () {
      $(this).val($(this).attr("placeholder"));
    })
    .autocomplete("instance")._renderItem = function (ul, item) {
    var li = "";
    li +=
      '<li><span class="item-wrapper">' +
      '<i class="icon-map"></i><span class="city-title">' +
      item.airportTitle +
      "</span></li>";

    return $(li).appendTo(ul);
  };

  // close location
  $(".js-cip-booking").delegate(".js-close-location-list", "click", function () {
    $(".js-cip-location").autocomplete("close");
    $(this).closest(".js-cip-booking-input").removeClass("is-open");
    $("html").removeClass("no-scroll");
  });

  $(".js-cip-location").click(() => {
    $(".js-cip-location").trigger("focus");
  });

  function flightType() {
    $(".js-cip-type")
      .autocomplete({
        minLength: 0,
        source: function (request, response) {
          let items = [];

          cipTripTypeList && cipTripTypeList.length
            ? cipTripTypeList.forEach((item) => {
                let title = item === 1 ? "پرواز بین المللی" : "پرواز داخلی";
                let tripType = item === 1 ? 1 : 2;
                cipFlightTypeList.forEach((type) => {
                  let typeTitle = type === 1 ? "ورودی" : "خروجی";
                  let flightType = type === 1 ? 1 : 2;
                  items.push({
                    title: `${title} - ${typeTitle}`,
                    tripType: tripType,
                    flightType: flightType,
                  });
                });
              })
            : [];

          if (Boolean(request.term)) items = items.filter((item) => item.title.search(request.term) !== -1);

          response(items);
          // if (request.term === "") {
          // var items = []

          // cipTripTypeList && cipTripTypeList.length
          //   ? cipTripTypeList.forEach(item => {

          //     let title = item === 1 ? 'پرواز بین المللی' : 'پرواز داخلی';
          //     let tripType = item === 1 ? 1 : 2
          //     cipFlightTypeList.forEach(type => {
          //       let typeTitle = type === 1 ? 'ورودی' : 'خروجی';
          //       let flightType = type === 1 ? 1 : 2
          //       items.push({
          //         title: `${title} - ${typeTitle}`,
          //         tripType: tripType,
          //         flightType: flightType
          //       })
          //     })

          //   })
          //   : [];

          // response(items);
          // }
          // else {
          //   var url = getResult($(".js-cip-type"));
          //   $.getJSON(url).done(function (serverResponse) {
          //     response(serverResponse.model);
          //   });
          // }
        },
        appendTo: $(".js-cip-type").next(),
        search: function () {
          $(this).closest(".js-cip-type-booking-input").addClass("is-open");
          if (window.innerWidth < 993) {
            $("html").addClass("no-scroll");
          }
        },
        select: function (event, ui) {
          $(this).attr("data-tripType", ui.item.tripType);
          $(this).attr("data-flightType", ui.item.flightType);
          $(this).val();

          $(this).data({
            triptype: ui.item.tripType,
            flighttype: ui.item.flightType,
          });  

          $(this).attr("placeholder", ui.item.title);
          $(this).closest(".js-cip-type-booking-input").removeClass("is-open");

          let timeOut = setTimeout(() => {
            $(".js-cip-booking").find(".js-pick-date").datepicker("show");
            document.activeElement.blur();
            clearTimeout(timeOut);
          }, 100);
        },
        open: function () {
          $(".ui-autocomplete").off("menufocus hover mouseover mouseenter");
          //off autocomplete in chrome
          let chromeAgent = navigator.userAgent.indexOf("Chrome") != -1;
          if (chromeAgent) {
            $(this).attr("autocomplete", "off");
          }
          var inputObj = $(this);
          inputObj
            .next(".js-autocomplete-type-list")
            .children("ul")
            .css({
              top: "+=" + 12,
            });
        },
        close: function (e, ui) {
          $("html").removeClass("no-scroll");
        },
      })
      .bind("focus", function () {
        $(this).val("");
        $(this).autocomplete("search");
      })
      .bind("blur", function () {
        $(this).val($(this).attr("placeholder"));
      })
      .autocomplete("instance")._renderItem = function (ul, item) {
      var li = "";
      li +=
        '<li><span class="item-wrapper">' +
        '<i class="icon-plane"></i><span class="city-title">' +
        item.title +
        "</span></li>";

      return $(li).appendTo(ul);
    };

    // close location
    $(".js-cip-booking").delegate(".js-close-location-list", "click", function () {
      $(".js-cip-location").autocomplete("close");
      $(this).closest(".js-cip-type-booking-input").removeClass("is-open");
      $("html").removeClass("no-scroll");
    });
  }
});

$(".js-cip-type").click(() => {
  $(".js-cip-type").trigger("focus");
});

// update auto complete after type
function getResult(input) {
  var dataUrl = "/cip-api/searchtitle/";

  if (input.val()) {
    dataUrl += input.val() + "/";
  }
  return dataUrl;
}

// append cip travel time list item
function appendTravelTimeList(items) {
  $(".js-cip-time-list").empty();

  if (items && items.length) {
    items.forEach(function (item) {
      $(".js-cip-time-list").append(
        "<li class='js-cip-time-item' data-value='" + item.value + "'>" + item.title + "</li>"
      );
    });
  }
}
